import { getNow, parseDateISO } from '@zorro/shared/formatters';

export const calculateAge = (dateOfBirth: string): number => {
  return getNow().diff(parseDateISO(dateOfBirth), 'year');
};

export const calculateAgeForEnrollment = (
  dateOfBirth: string,
  targetEnrollmentDate: string
): number => {
  return parseDateISO(targetEnrollmentDate).diff(
    parseDateISO(dateOfBirth),
    'year'
  );
};
